// router-view-provider
const RouterViewProvider = () => import('@/components/layout/router-view-provider.vue');

/**
 * 路由列表，根据auth字段控制菜但权限
 * 路由配置请保持和menu_list保持一致
 */
export default [
  {
    path: '/',
    component: () => import('@/components/main-layout.vue'),
    redirect: '/file_mine',
    children: [
      /**以下部分：兼容老版本，防止出错**/
      {
        path: '/file',
        name: 'file',
        components: {
          default: RouterViewProvider
        },
        redirect: {name: 'file_outer_upload'},
      },
      {
        path: '/file/outer/file_upload',
        name: 'file|outer|file_upload',
        components: {
          default: RouterViewProvider
        },
        redirect: {name: 'file_outer_upload'},
      },
      {
        path: '/file/outer/file_out_extra_info',
        name: 'file|outer|file_out_extra_info',
        components: {
          default: RouterViewProvider
        },
        redirect: {name: 'file_out_extra_info'},
      },
      {
        path: '/file/outer/file_out_completed',
        name: 'file|outer|file_out_completed',
        components: {
          default: RouterViewProvider
        },
        redirect: {name: 'file_out_completed'},
      },
      {
        path: '/file/outer/file_out_list',
        name: 'file|outer|file_out_list',
        components: {
          default: RouterViewProvider
        },
        redirect: {name: 'file_outer_file_out_list'},
      },
      {
        path: '/file/outer/subordinate_out_list',
        name: 'file|outer|subordinate_out_list',
        components: {
          default: RouterViewProvider
        },
        redirect: {name: 'file_outer_subordinate_out_list'},
      },
      {
        path: '/file/trace/alert_list',
        name: 'ile|trace|alert_list',
        components: {
          default: RouterViewProvider
        },
        redirect: {name: 'file_trace_alert_list'},
      },
      {
        path: '/file/trace/alert_detail',
        name: 'file|trace|alert_detail',
        components: {
          default: RouterViewProvider
        },
        redirect: {name: 'file_trace_alert_detail'},
      },
      {
        path: '/file/other_out/file_out_list',
        name: 'file|other_out|file_out_list',
        components: {
          default: RouterViewProvider
        },
        redirect: {name: 'compliance_audit_other_out_file_out_list'},
      },
      {
        path: '/file/other_out/view_apply',
        name: 'file|other_out|view_apply',
        components: {
          default: RouterViewProvider
        },
        redirect: {name: 'other_out_other_out_view_apply'},
      },
      {
        path: '/file/other_trace/alert_list',
        name: 'file|other_trace|alert_list',
        components: {
          default: RouterViewProvider
        },
        redirect: {name: 'compliance_audit_other_trace_alert_list'},
      },
      {
        path: '/file/other_trace/alert_detail',
        name: 'file|other_trace|alert_detail',
        components: {
          default: RouterViewProvider
        },
        redirect: {name: 'compliance_audit_other_trace_alert_detail'},
      },
      {
        path: '/file/other_trace/view_apply',
        name: 'file|other_trace|view_apply',
        components: {
          default: RouterViewProvider
        },
        redirect: {name: 'compliance_audit_other_trace_view_apply'},
      },
      /**以下部分：为新添加的URL**/
      {
        path: '/file_mine',
        name: 'file_mine',
        component: () => import('@/views/files/file-mine.vue'),
      },
      {
        path: '/client_mine',
        name: 'client_mine',
        component: () => import('@/views/cryptbox/client_mine.vue'),
      },
      {
        path: '/file_outer_upload',
        name: 'file_outer_upload',
        component: () => import('@/views/outer/file_apply/file_out_upload.vue'),
        beforeEnter: pc_mobile_switch
      },
      {
        path: '/file_out_extra_info',
        name: 'file_out_extra_info',
        component: () => import('@/views/outer/file_apply/file_out_extra_info.vue'),
        beforeEnter: pc_mobile_switch
      },
      {
        path: '/file_out_completed',
        name: 'file_out_completed',
        component: () => import('@/views/outer/file_apply/file_out_completed.vue'),
        beforeEnter: pc_mobile_switch
      },
      {
        path: '/file_outer',
        name: 'file_outer',
        redirect: 'file_outer/file_out_list',
        components: {
          default: RouterViewProvider,
        },
        children: [
          {
            path: 'file_out_list',
            name: 'file_outer_file_out_list',
            component: () => import('@/views/outer/file_apply/file_out_list.vue'),
            beforeEnter: pc_mobile_switch
          },
          {
            path: 'subordinate_out_list',
            name: 'file_outer_subordinate_out_list',
            component: () => import('@/views/outer/file_apply/subordinate_out_list.vue'),
            beforeEnter: pc_mobile_switch
          },
        ]
      },
      {
        path: '/file_trace',
        name: 'file_trace',
        redirect: 'file_trace/alert_list',
        components: {
          default: RouterViewProvider,
        },
        children: [
          {
            path: 'alert_list',
            name: 'file_trace_alert_list',
            component: () => import('@/views/file_trace/pc/alert_index.vue'),
            beforeEnter: pc_mobile_switch
          },
          {
            path: 'alert_detail',
            name: 'file_trace_alert_detail',
            component: () => import('./views/file_trace/pc/alert_detail.vue'),
            beforeEnter: pc_mobile_switch
          },
        ]
      },
      {
        path: '/compliance_audit',
        name: 'compliance_audit',
        redirect: 'compliance_audit/other_out',
        components: {
          default: RouterViewProvider,
        },
        children: [
          {
            path: 'other_out',
            name: 'compliance_audit_other_out',
            redirect: 'other_out/file_out_list',
            auth: ['file_outgoing'],
            components: {
              default: RouterViewProvider,
            },
          },
          {
            path: 'other_out/file_out_list',
            name: 'compliance_audit_other_out_file_out_list',
            auth: ['file_outgoing'],
            component: () => import('@/views/outer/file_apply/other_out_list.vue'),
            beforeEnter: pc_mobile_switch
          },
          {
            path: 'other_out/view_apply',
            name: 'other_out_other_out_view_apply',
            auth: ['file_outgoing'],
            component: () => import('@/views/outer/file_apply/other_view_apply.vue'),
            beforeEnter: pc_mobile_switch
          },
          {
            path: 'other_trace',
            name: 'compliance_audit_other_out',
            redirect: 'other_trace/alert_list',
            auth: ['file_trace_audit'],
            components: {
              default: RouterViewProvider,
            },
          },
          {
            path: 'other_trace/alert_list',
            name: 'compliance_audit_other_trace_alert_list',
            auth: ['file_trace_audit'],
            component: () => import('@/views/file_trace/others/alert_index.vue'),
            beforeEnter: pc_mobile_switch
          },
          {
            path: 'other_trace/alert_detail',
            name: 'compliance_audit_other_trace_alert_detail',
            auth: ['file_trace_audit'],
            component: () => import('@/views/file_trace/others/alert_detail.vue'),
            beforeEnter: pc_mobile_switch
          },
          {
            path: 'other_trace/view_apply',
            name: 'compliance_audit_other_trace_view_apply',
            auth: ['file_trace_audit'],
            component: () => import('@/views/file_trace/others/view_apply.vue'),
            beforeEnter: pc_mobile_switch
          },
        ]
      },
      {
        path: '/wenshu_device',
        name: 'wenshu_device',
        components: {
          default: RouterViewProvider
        },
        redirect: {name: 'wenshu_device_mount_apply'},
        children: [
          {
            path: 'mount_apply',
            name: 'wenshu_device_mount_apply',
            component: () => import('@/views/wenshu_device/mount_apply.vue')
          },
        ],
      },
      {
        path: '/wenshu_file_collect',
        name: 'wenshu_file_collect',
        component: () => import('@/views/wenshu_files/file_collect.vue')
      },
      {
        path: '/mobile_app_log_query',
        name: 'mobile_app_log_query',
        component: () => import('@/views/mobile_app/mobile_app_log_query.vue')
      },
    ],
  },
  {
    path: '/mobile',
    component: () => import('./components/router-view.vue'),
    redirect: {name: 'mobile_file_outer_file_out_list'},
    children: [
      {
        path: 'mobile_file_upload',
        name: 'mobile_file_outer_upload',
        component: () => import('./views/outer/mobile/mobile_file_upload.vue'),
        beforeEnter: pc_mobile_switch
      },
      {
        path: 'mobile_file_out_progress',
        name: 'mobile_file|outer|file_out_progress',
        component: () => import('./views/outer/mobile/mobile_file_out_progress.vue'),
      },
      {
        path: 'mobile_file_out_list',
        name: 'mobile_file_outer_file_out_list',
        component: () => import('./views/outer/mobile/mobile_file_out_list.vue'),
        beforeEnter: pc_mobile_switch
      },
      {
        path: 'mobile_404',
        name: 'mobile_file|404',
        component: () => import('./views/outer/mobile/mobile_404.vue'),
        beforeEnter: pc_mobile_switch
      },
      {
        path: 'other_out/other_out_list',
        name: 'mobile_compliance_audit_other_out',
        auth: ['file_outgoing'],
        component: () => import('@/views/outer/file_apply/mobile_not_support.vue'),
        beforeEnter: pc_mobile_switch
      },
      {
        path: 'outer/subordinate_out_list',
        name: 'mobile_file_outer_subordinate_out_list',
        component: () => import('@/views/outer/mobile/mobile_subordinate_out_list.vue'),
        beforeEnter: pc_mobile_switch
      },
      {
        path: 'other_out/view_apply',
        name: 'mobile_other_out_other_out_view_apply',
        auth: ['file_outgoing'],
        component: () => import('@/views/outer/file_apply/mobile_not_support.vue'),
        beforeEnter: pc_mobile_switch
      },
      {
        path: 'trace/alert_list',
        name: 'mobile_file_trace_alert_list',
        component: () => import('@/views/file_trace/mobile/alert_index.vue'),
        beforeEnter: pc_mobile_switch
      },
      {
        path: 'trace/alert_detail',
        name: 'mobile_file_trace_alert_detail',
        component: () => import('./views/file_trace/mobile/alert_detail.vue'),
        beforeEnter: pc_mobile_switch
      },
      {
        path: 'other_trace/alert_list',
        name: 'mobile_compliance_audit_other_trace_alert_list',
        component: () => import('@/views/outer/file_apply/mobile_not_support.vue'),
        beforeEnter: pc_mobile_switch
      },
      {
        path: 'other_trace/alert_detail',
        name: 'mobile_compliance_audit_other_trace_alert_detail',
        component: () => import('@/views/outer/file_apply/mobile_not_support.vue'),
        beforeEnter: pc_mobile_switch
      },
      {
        path: 'other_trace/view_apply',
        name: 'mobile_compliance_audit_other_trace_view_apply',
        component: () => import('@/views/outer/file_apply/mobile_not_support.vue'),
        beforeEnter: pc_mobile_switch
      },
    ]
  },
  {
    path: '/callback',
    name: 'callback',
    component: () => import('@/views/callback.vue')
  },
  {
    path: '/file/client_outer',
    name: 'file|client_outer',
    redirect: {name: 'file|client_outer|file_upload'},
    components: {
      default: RouterViewProvider
    },
    children: [
      {
        path: 'file_out_extra_info',
        name: 'file|client_outer|file_out_extra_info',
        component: () => import('@/views/outer/client_apply/file_out_extra_info.vue'),
      },
      {
        path: 'file_out_completed',
        name: 'file|client_outer|file_out_completed',
        component: () => import('@/views/outer/client_apply/file_out_completed.vue'),
      },
      {
        path: 'file_out_list',
        name: 'file|client_outer|file_out_list',
        component: () => import('@/views/outer/client_apply/file_out_list.vue'),
      },
      {
        path: 'file_upload',
        name: 'file|client_outer|file_upload',
        component: () => import('@/views/outer/client_apply/file_out_upload.vue'),
      },
      {
        path: 'modify_file_upload',
        name: 'file|client_outer|modify_file_upload',
        component: () => import('@/views/outer/client_apply/file_out_empty_page.vue'),
      },
      {
        path: 'continue_file_upload',
        name: 'file|client_outer|continue_file_upload',
        component: () => import('@/views/outer/client_apply/file_out_empty_page.vue'),
      },
      {
        path: 'open_client_dir',
        name: 'file|client_outer|open_client_dir',
        component: () => import('@/views/outer/client_apply/file_out_empty_page.vue'),
      },
    ]

  },
  {
    path: '/not_support',
    name: 'not_support',
    component: () => import('@/views/not_support.vue')
  },
  {
    path: '*',
    name: 'file|404',
    component: () => import('@/views/404.vue'),
    beforeEnter: pc_mobile_switch
  },
]

function pc_mobile_switch(to, from, next) {
  // 判断是否是手机端
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  let isMobile = (flag !== null);
  // 移动端点击首页（不带参数）
  if (to.name === 'file_outer_upload' && !to.query.hasOwnProperty('fileXmId')) {
    isMobile = false;
  }
  if (from.name === 'file_outer_upload' && (to.name === 'file_out_completed' || to.name === 'file_out_extra_info')) {
    next();
    return;
  }
  if (from.name === 'file_out_extra_info' && to.name === 'file_out_completed') {
    next();
    return;
  }

  // 获取下一个页面地址
  let nextName = to.name;
  if (isMobile) {
    // 跳转到手机端页面
    if (nextName.indexOf("mobile_") !== 0) {
      nextName = "mobile_" + nextName;
    }
  } else {
    // 跳转到pc端页面
    if (nextName.indexOf("mobile_") === 0) {
      nextName = nextName.substr(7);
    }
  }

  if (nextName === to.name) {
    next();
  } else {
    next({name: nextName, query: to.query});
  }
}
